module.exports = __webpack_public_path__ + "img/Eye_yellowgradient_icon.39b26b49.png";